module.exports = __webpack_public_path__ + "static/img/logoH.6d34fd81.svg";